import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CampoTexto } from './CamposFormulario';
import FilaAjuste from '../../../../components/ui/FilaAjuste';
import { normalizarTelefonoInternacional } from '../../../../utils/telefono';

/** Datos de contacto del usuario. Visible para admin y técnico. */
const FormularioInformacion = ({ usuarioData, form, errores, onCampo }) => {
  const { t } = useTranslation();
  const cambiar = (e) => onCampo(e.target.name, e.target.value);

  // Vista previa de cómo se leen las webs: una por dominio, sin repetidos
  const dominios = useMemo(
    () => [...new Set((form.webs_del_cliente || '').split(',').map((d) => d.trim()).filter(Boolean))],
    [form.webs_del_cliente],
  );

  return (
    <>
      <FilaAjuste titulo={t('comun.usuario')} texto={t('perfilUsuario.filas.usuarioTexto')}>
        <p className="pu-valor-fijo">@{usuarioData.usuario}</p>
      </FilaAjuste>

      <FilaAjuste titulo={t('perfilUsuario.filas.nombreTitulo')} texto={t('perfilUsuario.filas.nombreTexto')}>
        <div className="fila-ajuste-pareja">
          <CampoTexto
            id="campo-nombre"
            name="nombre"
            label={t('comun.nombre')}
            autoComplete="given-name"
            value={form.nombre}
            onChange={cambiar}
            error={errores.nombre}
          />
          <CampoTexto
            id="campo-apellidos"
            name="apellidos"
            label={t('comun.apellidos')}
            autoComplete="family-name"
            value={form.apellidos}
            onChange={cambiar}
            error={errores.apellidos}
          />
        </div>
      </FilaAjuste>

      <FilaAjuste titulo={t('perfilUsuario.filas.contactoTitulo')} texto={t('perfilUsuario.filas.contactoTexto')}>
        <CampoTexto
          id="campo-email"
          name="email"
          label={t('comun.email')}
          type="email"
          autoComplete="email"
          value={form.email}
          onChange={cambiar}
          error={errores.email}
        />
        <CampoTexto
          id="campo-telefono"
          name="telefono"
          label={t('comun.telefono')}
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          hint={t('perfilUsuario.telefonoInternacionalHint')}
          placeholder={t('perfilUsuario.telefonoInternacionalPlaceholder')}
          value={form.telefono}
          onChange={cambiar}
          onBlur={() => onCampo('telefono', normalizarTelefonoInternacional(form.telefono))}
          error={errores.telefono}
        />
      </FilaAjuste>

      <FilaAjuste titulo={t('perfilUsuario.websAsociadas')} texto={t('perfilUsuario.filas.websTexto')}>
        <CampoTexto
          id="campo-webs"
          name="webs_del_cliente"
          label={t('perfilUsuario.filas.dominios')}
          hint={t('perfilUsuario.websAsociadasHint')}
          placeholder={t('perfilUsuario.websAsociadasPlaceholder')}
          value={form.webs_del_cliente}
          onChange={cambiar}
        />
        {dominios.length > 0 && (
          <ul className="pu-dominios" aria-label={t('perfilUsuario.filas.dominiosGuardados')}>
            {dominios.map((dominio) => <li key={dominio}>{dominio}</li>)}
          </ul>
        )}
      </FilaAjuste>
    </>
  );
};

export default FormularioInformacion;
